import * as React from 'react';
import { cn } from '@/lib/utils';
import { Card } from '@/components/ui-kit/card';
import { Skeleton } from '@/components/ui-kit/skeleton';

export type StatStripItem = {
  label: React.ReactNode;
  value: React.ReactNode;
  /** A destructive figure (e.g. days under time). */
  tone?: 'default' | 'destructive';
};

interface StatStripProps {
  items: StatStripItem[];
  isLoading?: boolean;
  className?: string;
}

/**
 * A row of figures in one card, split by hairlines (HR Module Prototype, Component Map › stat strip:
 * `card` + `separator`): a muted 13px label over a 24px tabular value. Wraps to two columns on phones.
 */
export const StatStrip = ({ items, isLoading, className }: StatStripProps) => (
  <Card
    className={cn(
      'grid grid-cols-2 gap-px overflow-hidden bg-border p-0 shadow-none sm:flex',
      className
    )}
  >
    {items.map((item, index) => (
      <div key={index} className="flex min-w-0 flex-1 flex-col gap-1 bg-card px-4 py-3">
        <span className="truncate text-[13px] text-muted-foreground">{item.label}</span>
        {isLoading ? (
          <Skeleton className="h-7 w-16" />
        ) : (
          <span
            className={cn(
              'text-2xl font-semibold tabular-nums',
              item.tone === 'destructive' && 'text-destructive'
            )}
          >
            {item.value}
          </span>
        )}
      </div>
    ))}
  </Card>
);
